import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import React from 'react';
import {IMediaTrack} from '../../../../dto/MediaTrack.dto';
import {WalkupMusicSelectionTable} from '../WalkupMusicSelectionTable';
import {AllowedPlayerTypeKeys} from '../stepperComponents/SongMappingStepperCmpt';
import {INewWalkupPlayer} from '../stepperComponents/WalkupLineupStepper';
import {PlayerSelectionPanel} from './PlayerSelectionPanel';

export interface DesktopViewProps {
  isVisible: boolean;
  playerId: number;
  setPlayerId: React.Dispatch<React.SetStateAction<number>>;
  selectedPlayerType: AllowedPlayerTypeKeys;
  setSelectedPlayerType: React.Dispatch<
    React.SetStateAction<AllowedPlayerTypeKeys>
  >;
  currentFormStudents: INewWalkupPlayer[];
  track: IMediaTrack[];
  onSelect: (track: IMediaTrack) => void;
  onDeSelect: (track: IMediaTrack) => void;
  submit: () => void;
  isAthlete: boolean;
}

export const WalkupDesktopView = React.memo<DesktopViewProps>(
  ({
    isVisible,
    playerId,
    setPlayerId,
    selectedPlayerType,
    setSelectedPlayerType,
    currentFormStudents,
    track,
    onSelect,
    onDeSelect,
    submit,
    isAthlete,
  }) => {
    if (!isVisible) return null;

    return (
      <Dialog
        open
        fullWidth
        maxWidth='xl'
        sx={{display: {xs: 'none', md: 'block'}}}>
        <DialogTitle textAlign='center'>
          <Typography className='text-center font-bold'>
            STUDENT SELECTION FORM
          </Typography>
        </DialogTitle>
        <DialogContent sx={{padding: '0 !important'}}>
          <Grid container>
            <Grid
              item
              xs={12}
              md={3}
              className='h-630'
              sx={{
                background: `var(--blue_variant36)`,
              }}>
              <PlayerSelectionPanel
                selectedPlayerType={selectedPlayerType}
                setSelectedPlayerType={setSelectedPlayerType}
                playerId={playerId}
                setPlayerId={setPlayerId}
                players={currentFormStudents}
                isAthlete={isAthlete}
                isStudentForm={true}
              />
            </Grid>
            <Grid item xs={12} md={9} className='pt-6 pb-8 px-9'>
              <WalkupMusicSelectionTable
                selectedTracks={track}
                onSelect={onSelect}
                onDeselect={onDeSelect}
              />
              <Stack
                className='flex justify-center items-center mt-2'
                direction='row'
                spacing={2}>
                <Button variant='contained' onClick={submit}>
                  Submit
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    );
  },
);

WalkupDesktopView.displayName = 'WalkupDesktopView';
